
import { defineComponent, PropType } from 'vue'
import { ButtonStructure } from '@/contracts/forms/ButtonContracts'
import Button from '@/components/Button.vue'

export default defineComponent(
{
    name: 'Submit',
    emits: ['submitTriggered'],
    components:
    {
        Button
    },
    props:
    {
        name:
        {
            type: String
        },
        button:
        {
            type: Object as PropType<ButtonStructure>,
            default: {} as ButtonStructure
        }
    },
    setup(props, { emit })
    {
        // Handle button triggered:
        const handleButtonActionTriggered = () =>
        {
            emit('submitTriggered', props.name)
        }
        // Return data:
        return {
            handleButtonActionTriggered
        }
    }
})
